import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-numbers-cell-rederer',
  templateUrl: './numbers-cell-rederer.component.html',
  styleUrls: ['./numbers-cell-rederer.component.css'],
  standalone: true,
  imports: [DecimalPipe]
})
export class NumbersCellRedererComponent implements AfterViewInit {
  params: any;
  cellValue: any;
  email!: string | undefined;
  constructor() {}
  @ViewChild('content', { static: false }) container?: ElementRef;

  @ViewChild('trigger') button: any;

  ngAfterViewInit(): void {}

  /*   agInit(params: any) {

    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
  } */

  agInit(params: any) {
    this.params = params;
    const valueToDisplay = this.getValueToDisplay(params);

    if (valueToDisplay != null && valueToDisplay !== '') {
      const sanitizedValue = parseFloat(valueToDisplay.replace(/[^\d.-]/g, ''));

      if (!isNaN(sanitizedValue)) {
        this.cellValue = sanitizedValue;
      } else {
        this.cellValue = 0;
      }
    } else {
      this.cellValue = 0;
    }
  }

  /*   getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  } */

  getValueToDisplay(params: ICellRendererParams): string | undefined {
    const formattedValue = params.valueFormatted ? params.valueFormatted : (params.value || '').toString();

    if (formattedValue !== undefined && formattedValue !== null) {
      return (formattedValue || '').toString();
    }

    return '';
  }
}
